// @ts-nocheck
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import cloneDeep from "lodash/cloneDeep";

interface Parameter {
    embroideryOptionId?: string;
    embroideryText?: string;
}

interface Props {
    configurationEmbroideries: SafeDictionary<string>;
}

type HandlerType = Handler<Parameter, Props>;

export const CopyCurrentValues: HandlerType = props => {
    const productDetail = props.getState().pages.productDetails;
    props.configurationEmbroideries = cloneDeep(productDetail.configurationEmbroideries) || {};
};

export const SetConfigurationEmbroideries: HandlerType = props => {
    if (!props.parameter.embroideryOptionId) {
        return;
    }

    props.configurationEmbroideries[props.parameter.embroideryOptionId] = props.parameter.embroideryText;
};

export const DispatchUpdateConfigurationEmbroideries: HandlerType = props => {
    props.dispatch({
        type: "Pages/ProductDetails/UpdateConfigurationEmbroideries",
        configurationEmbroideries: props.configurationEmbroideries,
    });
};

export const chain = [CopyCurrentValues, SetConfigurationEmbroideries, DispatchUpdateConfigurationEmbroideries];

const updateConfigurationEmbroideries = createHandlerChainRunner(chain, "UpdateConfigurationEmbroideries");
export default updateConfigurationEmbroideries;
